function appendParams(url, params) {
	const query = Object.entries(params)
		.map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
		.join('&');
	const separator = url.indexOf('?') > 0 ? '&' : '?';

	return `${url}${separator}${query}`;
}

function getParam(url, paramName) {
	const search = url.split('?').pop();

	for (let param of search.split('&')) {
		param = param.split('=');

		if (param[0] === paramName) {
			return decodeURIComponent(param[1]);
		}
	}
}

export { appendParams, getParam };
